import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  inject,
  input,
  OnInit,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { LucideRefreshCcw } from '@lucide/angular';
import { ContractService } from '../contract-service';
import { ContractListItem } from '../contract.model';

@Component({
  selector: 'app-menu-contract-of-serie',
  imports: [CommonModule, LucideRefreshCcw, MatButtonModule, MatMenuModule],
  templateUrl: './menu-contract-of-serie.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./menu-contract-of-serie.scss'],
})
export class MenuContractOfSerie implements OnInit {
  firstContractId = input.required<string>();
  excludeContractsId = input<string[]>();
  contractClicked = output<string>();

  readonly contractService = inject(ContractService);
  readonly cdr = inject(ChangeDetectorRef);
  contracts: ContractListItem[] = [];

  ngOnInit(): void {
    this.contractService.listSeries(this.firstContractId()).subscribe((contracts) => {
      this.contracts = contracts;
      this.cdr.markForCheck();
    });
  }
}
